import React, { Component } from 'react';
import Header from '../components/header/header';
import TimeInterval from '../components/timeInterval/timeInterval';
import { Table, Button, Input, message, Popconfirm, Select, Pagination, ConfigProvider } from 'antd';
import Loading from '../../components/loading/loading';
import DocumentTitle from 'react-document-title';
import queryString from 'query-string';
import moment from 'moment';
import './baichengQuery.less';
import API from '../../../api/api';
import zhCN from 'antd/es/locale/zh_CN';
import baichengLogo from '../../../assets/image/query/baicheng/baichengLogo.png';
const { Option } = Select;
class DataQuery extends Component {
    constructor(props) {
        super(props);
        this.chooseDateRange = this.chooseDateRange.bind(this);
        this.clearTime = this.clearTime.bind(this);
    }
    state = {
        dataList: [],
        totalDataNum: 100,
        dataStatusList: [
            {
                id: '0',
                val: '全部',
            },
            {
                id: '1',
                val: '有购签时间',
            },
            {
                id: '2',
                val: '有加入俱乐部时间',
            },
            {
                id: '3',
                val: '有资料审核时间',
            },
            {
                id: '4',
                val: '有出签时间',
            },
        ],
        columns: [
            // userPhone
            {
                title: '客户手机号',
                dataIndex: 'userPhone',
                key: 'userPhone',
                width:150,
                render: (text, record) => (
                    <span >
                        {text}
                    </span>
                ),
            },
            // visaPayTime
            {
                title: '购签支付时间',
                dataIndex: 'visaPayTime',
                key: 'visaPayTime',
                width:150,
                render: (text, record) => (
                    text &&
                    <span >
                        {moment(text * 1000).format('YYYY/MM/DD HH:mm')}
                    </span>
                ),
            },
            // userRegisterTime
            {
                title: '加入俱乐部时间',
                dataIndex: 'userRegisterTime',
                key: 'userRegisterTime',
                width:150,
                render: (text, record) => (
                    text &&
                    <span >
                        {moment(text * 1000).format('YYYY/MM/DD HH:mm')}
                    </span>
                ),
            },
            // visaApplyTime
            {
                title: '资料审核时间',
                key: 'visaApplyTime',
                dataIndex: 'visaApplyTime',
                width:150,
                render: (text, record) => (
                    text &&
                    <span >
                        {moment(text * 1000).format('YYYY/MM/DD HH:mm')}
                    </span>
                ),
            },
            // visaPassTime
            {
                title: '出签时间',
                key: 'visaPassTime',
                dataIndex: 'visaPassTime',
                width:150,
                render: (text, record) => (
                    text &&
                    <span >
                        {moment(text * 1000).format('YYYY/MM/DD HH:mm')}
                    </span>
                ),
            },
            // 
            {
                title: '操作',
                width:150,
                render: (data) => (
                    data.userRegisterTime &&
                    <div className="operateBtnBlock" >
                        <Popconfirm title="确定再发一次通知吗？"
                            onConfirm={this.againNotice.bind(this, data.id)}
                            okText="确定"
                            cancelText="取消"
                        >
                            <Button key={'againBtn' + data.userPhone} type="primary" className="againBtn">再次通知</Button>
                        </Popconfirm>
                    </div>
                ),
            },
        ],
        apiData: {
            pageNum: 1,
            pageRows: 10,
            userPhone: '',
            startTime: '',
            endTime: '',
            timeType: 0,
        },
        timeKey:'1',
        totalCount:0,
        error: '',
        date: null,
    };
    componentWillReceiveProps() {
        this.submitSearch();
    }
    chooseDateRange(value) {
        console.log(value);
        const { apiData } = this.state;
        apiData.startTime = value.startTime;
        apiData.endTime = value.endTime;
        this.setState({ apiData });
    }
    againNotice(id) {
        let param={
            id:id
        }
        this.rePush(param)
    }
    rePush = async (param) => {
        let result = await API.baichengRepush(param);
        
        if (!result) return;
        if (result.status == 1) {
            message.success('已发送')
        }
        else{
            message.error(result.msg)
        }
    }
    clearTime() {
        const { apiData } = this.state;
        delete (apiData.startTime);
        delete (apiData.endTime);
        this.setState({ apiData });
    }
    // 分页选择
    pageChange(pageNumber, pageSize) {
        const { apiData } = this.state;
        if (pageNumber != apiData.pageNum) {
            apiData.pageNum = pageNumber
            this.setState({ apiData }, () => {
                this.submitSearch();
            });
        }
        window.scrollTo(0,0)
    }
    // 每页展示多少个
    onShowSizeChange(current, size) {
        const { apiData } = this.state;
        if (size != apiData.pageRows) {
            apiData.pageRows = size;
            apiData.pageNum = 1;
            this.setState({ apiData }, () => {
                this.submitSearch();
            });
        }
    }
    getDataList = async (param) => {
        let result = await API.getBaichengDataList(param);
        if (!result) return;
        if (result.status == 1) {
            this.setState({ dataList: result.data.dataList,totalCount:result.data.totalCount})
        }
    }
    dataStatusChange(value) {
        const { apiData } = this.state;
        apiData.timeType = value;
        this.clearTime();
        this.nullInputTime();
        this.setState({ apiData });
    }
    nullInputTime(){
        this.setState({ timeKey: new Date()});
    }
    phoneConditionChange(e) {
        const { apiData } = this.state;
        apiData.userPhone = e.target.value.trim();
        this.setState({ apiData });
    }
    submitSearch(type) {
        const { apiData } = this.state;
        if(type==1){
            apiData.pageNum=1;
            this.setState({apiData});
        }
        for (let key in apiData) {
            if (apiData[key] === '')
                delete (apiData[key])
        }
        this.getDataList(apiData)
    }
    render() {
        if (!this.state.dataList) {
            return <Loading></Loading>
        }
        const {
            columns,
            dataList,
            dataStatusList,
            apiData,
            totalCount,
            timeKey
        } = this.state;
        return (
            <DocumentTitle title="“百程俱乐部”数据查询系统">
                <ConfigProvider locale={zhCN}><div className="baichengQueryPane">
                    <Header roleName={'“百程俱乐部”数据查询系统'} systemColor='#7E61C9' systemLogoUrl={baichengLogo}></Header>
                    <div className="search-condition">
                        {/* 选择框 */}
                        <div className="condition-one">
                            {/* 状态选择 */}
                            <Select
                                defaultValue={apiData.timeType}
                                value={dataStatusList[apiData.timeType].val}
                                style={{ width: 120 }}
                                onChange={this.dataStatusChange.bind(this)}
                            >
                                {
                                    dataStatusList.map((item, index) => {
                                        return <Option value={item.id} key={item.id}>{item.val}</Option>
                                    })
                                }
                            </Select>
                        </div>

                        {/* 时间选择器 */}
                        <div className="time-tmp" id="time-tmp">
                            <TimeInterval
                                disabled={apiData.timeType==0?true:false}
                                className="timePicker"
                                confirmCallback={this.chooseDateRange}
                                clearTime={this.clearTime}
                                timeKey={timeKey}
                            ></TimeInterval>
                        </div>
                        {/* 手机号 */}
                        <Input placeholder="请输入手机号" className="search-phone" onChange={this.phoneConditionChange.bind(this)} />
                        {/* 搜索按钮 */}
                        <div className="search-btn" onClick={this.submitSearch.bind(this,1)}>搜索</div>
                    </div>
                    <div className="totalCount"><span></span>搜索结果数 {totalCount}</div>
                    {/* 数据列表 */}
                    <div className="data-list">
                        {/* 数据列表 */}
                        <div className="list-box">
                                <Table
                                    pagination={false}
                                    bordered
                                    rowClassName="tableTd"
                                    disabled
                                    width={150}
                                    rowKey={row => row.id}
                                    columns={columns}
                                    dataSource={dataList}
                                />
                        </div>
                        {/* 分页 */}
                        <div className="list-page" >
                                <Pagination
                                    defaultPageSize={apiData.pageRows}
                                    showQuickJumper
                                    showSizeChanger
                                    current={apiData.pageNum}
                                    defaultCurrent={apiData.pageNum}
                                    total={totalCount}
                                    pageSizeOptions={['10', '20', '30', '40', '50']}
                                    onShowSizeChange={this.onShowSizeChange.bind(this)}
                                    onChange={this.pageChange.bind(this)}
                                />
                        </div>
                    </div>
                </div>
                </ConfigProvider>
            </DocumentTitle>
        )
    }
}
export default DataQuery;